(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["abz-statistics-cards"] && !Shopify.designMode) return;
  try {
    class AbzStatisticsCards extends HTMLElement {
  connectedCallback() {
    this.frames = new Map();
    this.observer?.disconnect();
    const numbers = [...this.querySelectorAll('[data-stat-counter]')];
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    this.observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        this.observer.unobserve(entry.target);
        this.animateNumber(entry.target);
      }
    }, { threshold: 0.25 });
    numbers.forEach(number => {
      if (number.dataset.counted !== 'true') this.observer.observe(number);
    });
  }
  animateNumber(element) {
    if (element.dataset.counted === 'true') return;
    const original = element.dataset.statCounter;
    const match = original.match(/^(\D*)(\d[\d,]*(?:\.\d+)?)(\D*)$/);
    if (!match) return;
    const target = Number(match[2].replaceAll(',', ''));
    if (!Number.isFinite(target)) return;
    element.dataset.counted = 'true';
    const decimals = (match[2].split('.')[1] || '').length;
    const started = performance.now();
    const frame = now => {
      const progress = Math.min(1, Math.max(0, (now - started) / 5000));
      if (progress === 1) {
        element.textContent = original;
        this.frames.delete(element);
        return;
      }
      const value = (target * progress).toFixed(decimals);
      element.textContent = match[1] + (match[2].includes(',') ? Number(value).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) : value) + match[3];
      this.frames.set(element, requestAnimationFrame(frame));
    };
    frame(started);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.frames?.forEach((id, element) => {
      cancelAnimationFrame(id);
      element.textContent = element.dataset.statCounter;
    });
    this.frames?.clear();
  }
}
if (!customElements.get('abz-statistics-cards')) {
  customElements.define('abz-statistics-cards', AbzStatisticsCards);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_3ac1b38"] && !Shopify.designMode) return;
  try {
    class AbzStatisticsCounter extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.numbers = [...this.querySelectorAll('[data-stat-counter]')].map(element => {
      const original = element.dataset.statCounter;
      const match = original.match(/^(\D*)(\d[\d,]*(?:\.\d+)?)(\D*)$/);
      if (!match) return null;
      return { element, original, prefix: match[1], suffix: match[3], target: Number(match[2].replaceAll(',', '')), decimals: (match[2].split('.')[1] || '').length, grouped: match[2].includes(',') };
    }).filter(item => item && Number.isFinite(item.target));
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    this.numbers.forEach(item => { item.element.textContent = item.prefix + '0' + item.suffix; });
    this.observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      this.observer.disconnect();
      this.startCount();
    }, { threshold: 0.1 });
    this.observer.observe(this.querySelector('[data-stat-grid]') || this);
  }
  startCount() {
    if (this.started) return;
    this.started = true;
    let started;
    const frame = now => {
      if (started === undefined) started = now;
      const progress = Math.min(1, Math.max(0, (now - started) / (8000 / 1.2)));
      this.numbers.forEach(item => {
        if (progress === 1) {
          item.element.textContent = item.original;
          return;
        }
        const scale = Math.pow(10, item.decimals);
        const number = Math.floor(item.target * progress * scale) / scale;
        const value = item.grouped ? number.toLocaleString('en-US', { minimumFractionDigits: item.decimals, maximumFractionDigits: item.decimals }) : number.toFixed(item.decimals);
        const text = item.prefix + value + item.suffix;
        if (item.element.textContent !== text) item.element.textContent = text;
      });
      this.frame = progress < 1 ? requestAnimationFrame(frame) : null;
    };
    this.frame = requestAnimationFrame(frame);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
    this.numbers?.forEach(item => { item.element.textContent = item.original; });
    if (!this.started) this.initialized = false;
  }
}
if (!customElements.get('abz-statistics-counter')) customElements.define('abz-statistics-counter', AbzStatisticsCounter);
  } catch(e) { console.error(e); }
})();

})();
